import Refluxr from '../../lib/refluxr';
import { OnlineApi } from '../services';
import FeedbackActions from './feedback.actions';
import handleSetupFormPreviewFailure from '../components/forms/handleSetupFormPreviewFailure';
let container = require('../core/container');
import common from '../common';

const constants = common.constants;

function sleep(ms) {
   return new Promise((resolve) => setTimeout(resolve, ms));
}
function FormActions() {
   var Actions = Refluxr.createActions(
      [
         'ensureBlankFormSync',
         'requiresForm',
         {
            setupFormPreview: OnlineApi.send,
            prepare: function (args) {
               args.ignoreErrorFeedback = true;
               const { noForm, name, description, scoringEnabled = false, scoreVisible = false, items, noLocation } = args;
               const o = {
                  messageType: 'SETUP_FORM_PREVIEW',
                  noForm,
                  name,
                  description,
                  scoringEnabled,
                  scoreVisible,
                  items,
                  noLocation
               };

               return o;
            }
         },
         {
            loadForm: OnlineApi.send,
            prepare: function ({ noForm }) {
               const o = {
                  messageType: 'FETCH_FORMS',
                  idFormViewType: 0,
                  searchText: null,
                  filters: [{ field: 'no', value: noForm }],
                  withTags: [],
                  withoutTags: [],
                  limit: 1,
                  page: 1,
                  forSelect: false
               };

               return o;
            }
         },
         ,
         'dump',
         'resetSync',
         'saveSync'
      ],
      container.getGlobalHandler(),
      container.getFeedbackHandler()
   );

   Actions.setupFormPreview.failed.listen((response) => {
      if (response && response.input && response.input.showOperationalFeedback === false) {
         return;
      }

      handleSetupFormPreviewFailure({ response, showError: FeedbackActions.showError });
   });

   return Actions;
}

FormActions.instance = new FormActions();

export default FormActions.instance;
